export const SAVE_USER_WEATHER_SETTINGS_MUTATION = `
  mutation saveUserWeatherDashBoard($data: UserDataWeatherInput!) {
    userData(data: $data) {
      day
      display_label
      id
      location_id
      provider
      unit
      user_id
    }
  }
`;
